@if (_active) {
  <kendo-window (close)="_closeForm()" [title]="reportId ? 'Edit Record' : 'Add New Record'" (stateChange)="_onStateChanges($event)"
    class="forecastForm customForecastWindow">
    <form [formGroup]="editForm" class="forecast-form-layout">
      <div class="forecast-form-body">
        <div class="col-12" style="padding: 0;">
          <div class="bordered_sections stepperSection">
            <div class="col-12 import_title">Follow the Steps</div>
            <kendo-stepper [steps]="_steps" [stepType]="'full'" [(currentStep)]="currentStep" [linear]="false"
              (stepSelect)="goToStep($event.index)">
            </kendo-stepper>
          </div>
        </div>
        <div class="col-12">
          <div class="row stepsRowMargin">
            <div class="col-12 col-md-6 stepsColPadding" (click)="goToStep(0)">
              <div class="row">
                <div class="col-12">
                  <p class="step_title" (click)="goToStep(0)">Step 1: <span class="stepDescription">select account</span></p>
                </div>
                <div class="col-12" [class.active-step-forcast]="currentStep === 0">
                  <div class="bordered_sections_special min-height-section" (click)="goToStep(0)">
                    <div class="form-group">
                      <label class="control-label trl" for="forecastName">Forecast name</label>
                      <input type="text" class="k-textbox writebox" formControlName="forecastName"
                        required />
                      </div>
                      <div class="form-group">
                        <label class="control-label trl" for="selectedAccount">Account</label>
                        <kendo-multiselect [summaryTagAfter]="0" [data]="listaccounts" [textField]="'name'"
                          [valueField]="'id'" formControlName="selectedAccount"
                          [value]="_selectedAccount" class="reportviewerMS addNewForecastMS" required>
                        </kendo-multiselect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-12 col-md-6 stepsColPadding min-height-section" (click)="goToStep(1)">
                <div class="row">
                  <div class="col-12">
                    <p class="step_title" (click)="goToStep(1)">
                      Step 2: <span class="stepDescription">choose transaction</span>
                    </p>
                  </div>
                  <div class="col-12">
                    <div class="bordered_sections_special bordered_sections_special_right stepMinHeight"
                      [class.active-step-forcast]="currentStep === 1" (click)="goToStep(1)">
                      <div class="row">
                        <div class="col-12 col-sm-6">
                          <label class="k-radio-label forecastRadioLabel" for="transaction">
                            receive
                            transaction
                          </label>
                          <input type="radio" name="transaction" value="ReceiveTransaction"
                            formControlName="transaction" kendoRadioButton />
                            @if (editForm.get('transaction').value == 'ReceiveTransaction') {
                              <div class="margin-top-5">
                                <label class="control-label trl normalfont">Select vendor(s)</label>
                                <kendo-multiselect [summaryTagAfter]="0" [data]="listvendors" [textField]="'name'"
                                  [valueField]="'id'" formControlName="selectedVendors"
                                  [value]="_selectedVendors" class="reportviewerMS addNewForecastMS">
                                </kendo-multiselect>
                              </div>
                            }
                          </div>
                          <div class="col-12 col-sm-6 leftBorder">
                            <div class="row">
                              <div class="col-12">
                                <label class="k-radio-label forecastRadioLabel"
                                  for="transaction">
                                  issue
                                  transaction
                                </label>
                                <input type="radio" name="transaction" value="IssueTransaction"
                                  formControlName="transaction" kendoRadioButton />
                                </div>
                                @if (editForm.get('transaction').value == 'IssueTransaction') {
                                  <div class="col-12"
                                    >
                                    <input type="checkbox" formControlName="accountForReturn"
                                      kendoCheckBox />
                                      <label class="k-radio-label forecastCheckboxLabel"
                                        for="accountForReturn">
                                        account for
                                        returns
                                      </label>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="row stepsRowMargin">
                    <div class="col-12 col-md-4 stepsColPadding" (click)="goToStep(2)">
                      <div class="row">
                        <div class="col-12">
                          <p class="step_title" (click)="goToStep(2)">
                            Step 3: <span class="stepDescription">
                            choose forecast
                            method
                          </span>
                        </p>
                      </div>
                      <div class="col-12">
                        <div class="bordered_sections_special minHeightSection"
                          [class.active-step-forcast]="currentStep === 2" (click)="goToStep(2)">
                          <div class="row">
                            <div class="col-12">
                              <div class="sectionsHeadTitle">Forecast Method</div>
                            </div>
                            <div class="col-12">
                              <div class="form-group">
                                <label class="control-label trl normalfont">Previous months</label>
                                <kendo-numerictextbox type="text" class="k-numerictextbox"
                                  formControlName="intervalValue">
                                </kendo-numerictextbox>
                              </div>
                            </div>
                            <div class="col-12">
                              <div class="inSectionsSeparators"></div>
                            </div>
                            <div class="col-12">
                              <div class="sectionsHeadTitle">date settings</div>
                            </div>
                            <div class="col-12 margin_button_10">
                              <label class="k-radio-label trl normalfont" for="forecastdate">
                                next
                                possible date
                              </label>
                              <input type="radio" name="forecastdate" value="nextPossibleDate"
                                formControlName="forecastdate" kendoRadioButton />
                              </div>
                              <div class="col-12 margin_button_10">
                                <label class="k-radio-label trl normalfont" for="forecastdate">
                                  Provide
                                  Date
                                </label>
                                <input type="radio" name="forecastdate" value="provideDate"
                                  formControlName="forecastdate" kendoRadioButton />
                                </div>
                                @if (editForm.get('forecastdate').value == 'provideDate') {
                                  <div class="col-12 margin_button_10"
                                    >
                                    <label for="providedDate" class="k-radio-label trl normalfont">
                                      started
                                      date
                                    </label>
                                    <kendo-datepicker [bottomView]="'year'"
                                      (valueChange)="onProvidedDateChange($event)" [topView]="'decade'"
                                      [value]="providedDateValue" [format]="'MMMM yyyy'"
                                    fromControlName="providedDate"></kendo-datepicker>
                                  </div>
                                }
                                <div class="col-12">
                                  <label class="control-label trl normalfont">forecast for</label>
                                  <kendo-numerictextbox type="text" class="k-numerictextbox"
                                    formControlName="forecastFor" class="k-numerictextbox">
                                  </kendo-numerictextbox>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-4 stepsColPadding" (click)="goToStep(3)">
                        <div class="row">
                          <div class="col-12">
                            <p class="step_title" (click)="goToStep(3)">
                              Step 4: <span class="stepDescription">choose variance</span><span class="optionalStyle"> - optional</span>
                            </p>
                          </div>
                          <div class="col-12">
                            <div class="bordered_sections_special minHeightSection"
                              [class.active-step-forcast]="currentStep === 3" (click)="goToStep(3)">
                              <div class="row">
                                <div class="col-12 margin_button_10">
                                  <label class="control-label trl" for="overage">overage/shrinkage*</label>
                                  <kendo-numerictextbox type="text" class="k-numerictextbox"
                                    formControlName="overage">
                                  </kendo-numerictextbox>
                                </div>
                                <div class="col-12">
                                  <label class="control-label trl" for="replenish">replenish</label>
                                  <kendo-numerictextbox type="text" class="k-numerictextbox"
                                    formControlName="replenish">
                                  </kendo-numerictextbox>
                                </div>
                                <div class="col-12">
                                  <div class="inSectionsSeparators"></div>
                                </div>
                                <div class="col-12 margin_button_10">
                                  <div class="sectionUnderDescription">
                                    *for shrinkage use a negative value
                                  </div>
                                </div>
                                <!-- Inventory Options Checkboxes -->
                                <div class="col-12 margin_button_10">
                                  <input type="checkbox" kendoCheckBox formControlName="accoutForAllocate" id="chkAllocate" />
                                  <label class="k-radio-label forecastCheckboxLabel" for="chkAllocate" style="margin-left: 6px;">
                                    account for allocation
                                  </label>
                                </div>
                                <div class="col-12 margin_button_10">
                                  <input type="checkbox" kendoCheckBox formControlName="accoutForMin" id="chkMin" />
                                  <label class="k-radio-label forecastCheckboxLabel" for="chkMin" style="margin-left: 6px;">
                                    account for min
                                  </label>
                                </div>
                                <div class="col-12">
                                  <input type="checkbox" kendoCheckBox formControlName="exceedMax" id="chkMax" />
                                  <label class="k-radio-label forecastCheckboxLabel" for="chkMax" style="margin-left: 6px;">
                                    exceed max
                                  </label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-12 col-md-4 stepsColPadding" (click)="goToStep(4)">
                        <div class="row">
                          <div class="col-12">
                            <p class="step_title" (click)="goToStep(4)">
                              Step 5: <span class="stepDescription">choose condition</span><span class="optionalStyle"> - optional</span>
                            </p>
                          </div>
                          <div class="col-12">
                            <div class="bordered_sections_special bordered_sections_special_right minHeightSection"
                              [class.active-step-forcast]="currentStep === 4" (click)="goToStep(4)">
                              <div class="row">
                                <div class="col-12 margin_button_10">
                                  <label class="control-label trl" for="conditionName">
                                    condition
                                    name
                                  </label>
                                  <input type="text" class="k-textbox writebox"
                                    formControlName="conditionName" />
                                  </div>
                                  <div class="col-12 margin_button_10">
                                    <label class="control-label trl" for="initialValue">initial value</label>
                                    <kendo-numerictextbox type="text" class="k-numerictextbox"
                                      formControlName="initialValue">
                                    </kendo-numerictextbox>
                                  </div>
                                  <div class="col-12">
                                    <label class="control-label trl" for="tragetedValue">
                                      targeted
                                      value
                                    </label>
                                    <kendo-numerictextbox type="text" class="k-numerictextbox"
                                      formControlName="targetedValue">
                                    </kendo-numerictextbox>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  @if (_invalidForm) {
                    <asap-forms-validation-summary [form]="_currentForm" [page]="'customForcast'">
                    </asap-forms-validation-summary>
                  }
                  <!-- DOCKED ACTION FOOTER (ALWAYS VISIBLE WITHOUT SCROLLING) -->
                  <div class="forecast-form-footer">
                    <button kendoButton class="steps_buttons_class" (click)="_closeForm()">
                      <img class="backimage" [src]="'/assets/menu/'+ (_theme || 'enterprise') +'/close-schedule-report-icon-green.svg'" />
                      <span>close</span>
                    </button>
                    <button [disabled]="!canSave()" kendoButton class="steps_buttons_class" (click)="SaveAndClose(true)">
                      <img class="backimage" [src]="'/assets/menu/'+ (_theme || 'enterprise') +'/save-icon-group.svg'" />
                      <span>Save & Process</span>
                    </button>
                    <button [disabled]="!canSave()" kendoButton class="steps_buttons_class" (click)="SaveAndClose(false)">
                      <img class="backimage" [src]="'/assets/menu/'+ (_theme || 'enterprise') +'/save-close-icon.svg'" />
                      <span>Save & Close</span>
                    </button>
                  </div>
                </form>
              </kendo-window>
            }
